// extracted by mini-css-extract-plugin
module.exports = {"body":"RequestItem_body__3cWXr","buttons":"RequestItem_buttons__19Nqt"};